webpackJsonp([1],Array(144).concat([
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(273);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
var defaultLocale = __webpack_require__.i({"NODE_ENV":"production","DEBUG_MODE":false,"DEV_TOOLS":false,"PRODUCTION_TIP":false,"API_URL":""}).DEFAULT_LOCALE;

var languages = {};

var files = __webpack_require__(329);

files.keys().forEach(function (key) {
  var re = /.*(..+)(.lang.json)$/;
  var language = re.exec(key)[1];

  var folder = /.+?(?=lang)/;
  var parseFolderName = /[A-Za-z]+/;
  var folderName = parseFolderName.exec(folder.exec(key))[0];

  if (!languages[language]) {
    languages[language] = {};
  }
  languages[language][folderName] = files(key);
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: defaultLocale,
  fallbackLocale: 'da',
  messages: languages
}));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_moment__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_moment__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_moment___default.a, __WEBPACK_IMPORTED_MODULE_1_moment___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(this.language);
  },

  computed: {
    language: function language() {
      return this.$i18n.locale;
    }
  },
  watch: {
    language: function language() {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(this.language);
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(324);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [];

var files = __webpack_require__(330);

files.keys().forEach(function (key) {
  if (!files(key).default) {
    return;
  }

  var routesFile = files(key).default;
  var length = routesFile.length;
  for (var i = 0; i < length; i++) {
    routes.push(routesFile[i]);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: routes
}));

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(327);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        mobileMenu: false
    },
    modules: {}
}));

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deveodk_vue_toastr__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deveodk_vue_seo__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__deveodk_vue_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progressbar__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(270);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_progressbar___default.a, {
    color: 'white',
    failedColor: 'red',
    height: '2px'
});


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* default */]);

var API_URL = "";

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = API_URL;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__deveodk_vue_seo___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_quooker__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_quooker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_quooker__);



var routes = [{
    path: '/cases',
    name: 'Cases',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}, {
    path: '/case/quooker',
    name: 'CaseQuooker',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_quooker___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/core',
    name: 'Core',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
  path: '/',
  name: 'Index',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/press',
    name: 'Press',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/services',
    name: 'Services',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_index__);


var routes = [{
    path: '/technologies',
    name: 'Technology',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_index___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = (routes);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export remove */
/* unused harmony export post */
/* unused harmony export put */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);


var get = function get(path, data, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(path, { params: data }).then(function (response) {
        cb(response);
    }).catch(function (error) {
        errorCb(error);
    });
};

var remove = function remove(path, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(path).then(function (response) {
        cb(response);
    }).catch(function (error) {
        errorCb(error);
    });
};

var post = function post(path, data, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(path, data).then(function (response) {
        cb(response);
    }).catch(function (error) {
        errorCb(error);
    });
};

var put = function put(path, data, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(path, data).then(function (response) {
        cb(response);
    }).catch(function (error) {
        errorCb(error);
    });
};



/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDownloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPackagistDownloads; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpService__ = __webpack_require__(180);


var npmNamespace = 'https://api.npmjs.org/downloads/point/last-year/@deveodk/';
var githubNamespace = 'https://api.github.com/repos/Deveodk/';
var packagistNamespace = 'https://packagist.org/packages/deveodk/';

var getDownloads = function getDownloads(repo, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](npmNamespace + repo, params, cb, errorCb);
};

var getStars = function getStars(repo, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](githubNamespace + repo, params, cb, errorCb);
};

var getPackagistDownloads = function getPackagistDownloads(repo, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0__HttpService__["a" /* get */](packagistNamespace + repo + '.json', params, cb, errorCb);
};



/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_packages_packages__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__infrastructure_lang_locale__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__infrastructure_lang_moment__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__infrastructure_router_router__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__infrastructure_store_store__ = __webpack_require__(147);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = false;

__WEBPACK_IMPORTED_MODULE_6__infrastructure_router_router__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_6__infrastructure_router_router__["a" /* default */].app.$Progress.start();
    next();
});

__WEBPACK_IMPORTED_MODULE_6__infrastructure_router_router__["a" /* default */].afterEach(function () {
    __WEBPACK_IMPORTED_MODULE_6__infrastructure_router_router__["a" /* default */].app.$Progress.finish();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    i18n: __WEBPACK_IMPORTED_MODULE_4__infrastructure_lang_locale__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_7__infrastructure_store_store__["a" /* default */],
    mixins: [__WEBPACK_IMPORTED_MODULE_5__infrastructure_lang_moment__["a" /* default */]],
    router: __WEBPACK_IMPORTED_MODULE_6__infrastructure_router_router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_layout_layout__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_layout_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__app_layout_layout__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        layout: __WEBPACK_IMPORTED_MODULE_0__app_layout_layout___default.a
    },
    mounted: function mounted() {
        this.checkDomain();
    },

    methods: {
        checkDomain: function checkDomain() {
            var url = document.location.toString();

            if (url.indexOf('.io') !== -1) {
                this.$i18n.locale = 'en';

                return;
            }

            this.$i18n.locale = 'da';
        }
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        name: {},
        type: {},
        shortname: {},
        position: {}
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['job', 'author', 'name', 'type', 'shortname', 'position'],
    data: function data() {
        return {
            loadedState: 'not-loaded'
        };
    },
    mounted: function mounted() {
        var self = this;
        if (this.shortname === 'julehjaelpen') {
            $('<img/>').attr('src', '/static/images/cases/new/jh_hd.jpg').on('load', function () {
                self.loadedState = 'loaded';
            });
        }
        if (this.shortname === 'volkswagen') {
            $('<img/>').attr('src', '/static/images/cases/new/vw_hd.jpg').on('load', function () {
                self.loadedState = 'loaded';
            });
        }
        if (this.shortname === 'quooker') {
            $('<img/>').attr('src', '/static/images/cases/new/q_hd.jpg').on('load', function () {
                self.loadedState = 'loaded';
            });
        }
        if (this.shortname === 'apmp') {
            $('<img/>').attr('src', '/static/images/cases/new/apmp_hd.jpg').on('load', function () {
                self.loadedState = 'loaded';
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_case__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_case__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_new_case__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_new_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_new_case__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_img_loader__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_img_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_img_loader__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Case: __WEBPACK_IMPORTED_MODULE_0__components_case___default.a,
        newCase: __WEBPACK_IMPORTED_MODULE_1__components_new_case___default.a,
        'vue-img-loader': __WEBPACK_IMPORTED_MODULE_2_vue_img_loader___default.a
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            submitted: false,
            submitSuccess: false,
            form: {
                name: '',
                email: '',
                phone: '',
                message: ''
            }
        };
    },

    methods: {
        encode: function encode(data) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
            }).join('&');
        },
        handleSubmit: function handleSubmit() {
            var _this = this;

            fetch('/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: this.encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'form-name': 'contact' }, this.form))
            }).then(function () {
                _this.submitted = true;
                _this.submitSuccess = true;
            }).catch(function () {
                _this.submitted = true;
            });
        }
    },
    computed: {
        isValidated: function isValidated() {
            var form = this.form;
            if (this.errors.items.length > 0) {
                return false;
            }
            if (form.name === '') {
                return false;
            }
            if (form.email === '') {
                return false;
            }
            if (form.phone === '') {
                return false;
            }
            if (form.message === '') {
                return false;
            }
            return true;
        }
    }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            language: 'hejsa'
        };
    }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            locales: this.$i18n.messages,
            titanic: {
                x: -400,
                y: 220,
                multiplier: 1
            },
            pressedKeys: {
                left: false,
                right: false,
                up: false,
                down: false
            },
            loop: null
        };
    },
    mounted: function mounted() {
        window.addEventListener('keydown', this.detectKeyDown);
        window.addEventListener('keyup', this.detectKeyUp);
        this.gameLoop();
        this.pressedKeys.right = true;
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keydown', this.detectKeyDown);
        window.removeEventListener('keyup', this.detectKeyUp);
        clearInterval(this.loop);
    },

    methods: {
        gameLoop: function gameLoop() {
            var _this = this;

            this.loop = setInterval(function () {
                _this.detectMove();
            }, 40);
        },
        detectKeyDown: function detectKeyDown() {
            var pressedKeys = this.pressedKeys;

            switch (event.key) {
                case 'ArrowLeft':
                    pressedKeys.left = true;
                    break;
                case 'ArrowRight':
                    pressedKeys.right = true;
                    break;
            }
        },
        detectKeyUp: function detectKeyUp() {
            var pressedKeys = this.pressedKeys;

            switch (event.key) {
                case 'ArrowLeft':
                    pressedKeys.left = false;
                    break;
                case 'ArrowRight':
                    pressedKeys.right = false;
                    break;
            }
        },
        detectMove: function detectMove() {
            var pressed = this.pressedKeys;

            if (window.innerWidth - 300 < this.titanic.x) {
                this.titanic.x = -300;
            }

            if (pressed.left) {
                this.moveTitanic(-1);
            }

            if (pressed.right) {
                this.moveTitanic(1);
            }
        },
        moveTitanic: function moveTitanic(dx) {
            var titanic = this.titanic;

            titanic.x += (dx || 0) * titanic.multiplier;
        }
    }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            show: true
        };
    },
    mounted: function mounted() {
        this.checkCookieAccept();
    },

    methods: {
        checkCookieAccept: function checkCookieAccept() {
            var accepted = localStorage.getItem('cookies_accepted');
            if (accepted) {
                this.show = false;
            }
        },
        acceptCookie: function acceptCookie() {
            localStorage.setItem('cookies_accepted', true);
            this.show = false;
        },
        goAway: function goAway() {
            var lang = this.$i18n.locale;

            if (lang === 'da') {
                window.location.href = 'https://www.google.dk/search?q=alternativ+til+københavns+bedste+software+bureau';

                return;
            }

            window.location.href = 'https://www.google.dk/search?q=alternative+to+copenhagens+best+software+agency';
        }
    }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MainFooter',
    props: {
        skew: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data: function data() {
        return {
            locales: this.$i18n.messages,
            socials: [{
                name: 'LinkedIn',
                link: 'https://www.linkedin.com/company/17890131/'
            }, {
                name: 'Facebook',
                link: 'https://www.facebook.com/deveodk/'
            }, {
                name: 'GitHub',
                link: 'https://github.com/deveodk'
            }, {
                name: 'npmjs',
                link: 'https://www.npmjs.com/~deveodk'
            }, {
                name: 'Open-source',
                link: 'https://packages.deveo.io'
            }],
            contacts: [{
                title: '+45 71 99 28 95',
                link: 'tel:+4571992895'
            }, {
                title: 'kontakt@deveo.dk',
                link: 'mailto:kontakt@deveo.dk'
            }, {
                title: 'Nordborggade 8, st <br> 2100 København Ø',
                link: 'https://www.google.dk/maps/place/Nordborggade+8,+2100+K%C3%B8benhavn+%C3%98/@55.6971168,12.5845689,17z/data=!4m13!1m7!3m6!1s0x465252e3f900106d:0x6181940053502815!2sNordborggade+8,+2100+K%C3%B8benhavn+%C3%98!3b1!8m2!3d55.6971168!4d12.5867576!3m4!1s0x465252e3f900106d:0x6181940053502815!8m2!3d55.6971168!4d12.5867576?hl=en'
            }]
        };
    },

    computed: {
        currentYear: function currentYear() {
            return new Date().getFullYear();
        },

        sortedSocials: function sortedSocials() {
            function compare(a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            }

            return this.socials.sort(compare);
        }
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__top_menu_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__top_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__top_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mobile_footer_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mobile_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mobile_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobile_menu_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobile_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mobile_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cookie_notice_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cookie_notice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cookie_notice_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'layout',
    components: {
        topMenu: __WEBPACK_IMPORTED_MODULE_0__top_menu_vue___default.a,
        mainFooter: __WEBPACK_IMPORTED_MODULE_1__footer_vue___default.a,
        mobileFooter: __WEBPACK_IMPORTED_MODULE_2__mobile_footer_vue___default.a,
        mobileMenu: __WEBPACK_IMPORTED_MODULE_3__mobile_menu_vue___default.a,
        cookieNotice: __WEBPACK_IMPORTED_MODULE_4__cookie_notice_vue___default.a
    },
    watch: {
        '$i18n.locale': 'setLanguage'
    },
    created: function created() {
        this.checkLanguage();
    },

    methods: {
        checkLanguage: function checkLanguage() {
            var chosenLanguage = localStorage.getItem('chosenLanguage');
            if (!chosenLanguage) {
                return;
            }
            this.$i18n.locale = chosenLanguage;
        },
        setLanguage: function setLanguage() {
            localStorage.setItem('chosenLanguage', this.$i18n.locale);
        }
    },
    computed: {
        skewFooter: function skewFooter() {
            var currentRoute = this.$route.name;

            switch (currentRoute) {
                case 'Index':
                    return false;
                case 'Contact':
                    return false;
                default:
                    return true;
            }
        }
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            locales: this.$i18n.messages
        };
    },

    methods: {
        changeRoute: function changeRoute(path) {
            this.$router.push({ name: path });
            this.$store.state.mobileMenu = false;
        }
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            windowBox: 1
        };
    }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['header', 'footer', 'svg']
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        header: {
            required: true
        },
        description: {},
        downloads: {
            required: true
        },
        type: {},
        stars: {}
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'description', 'icon']
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        size: {
            required: true
        },
        icon: {
            required: true
        }
    }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_typer__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_typer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_typer__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showTerminal: true
        };
    },

    components: {
        'vue-typer': __WEBPACK_IMPORTED_MODULE_0_vue_typer__["VueTyper"]
    },
    created: function created() {
        var _this = this;

        window.onlineInterval = setInterval(function () {
            _this.restartTerminal();
        }, 17000);
    },

    beforeDestroy: window.clearInterval(window.onlineInterval),
    methods: {
        restartTerminal: function restartTerminal() {
            var _this2 = this;

            this.showTerminal = false;
            setTimeout(function () {
                _this2.showTerminal = true;
            }, 1);
        }
    }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pro_point__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pro_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pro_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_tech__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_other_tech___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_other_tech__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tech_bubble__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tech_bubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tech_bubble__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_terminal__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_terminal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_terminal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_package__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__ = __webpack_require__(181);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Technologies',
    data: function data() {
        return {
            packages: {
                vueAnimate: { downloads: '', stars: '' },
                vueSeo: { downloads: '', stars: '' },
                vueOnline: { downloads: '', stars: '' },
                vueToastr: { downloads: '', stars: '' },
                vueErrorTracker: { downloads: '', stars: '' },
                vueTinymce: { downloads: '', stars: '' },
                distributedGenerators: { downloads: '', stars: '' },
                core: { downloads: '', stars: '' },
                laravelApiAuth: { downloads: '', stars: '' },
                laravelCoreTimeTracker: { downloads: '', stars: '' }
            }
        };
    },

    computed: {
        totalDownloads: function totalDownloads() {
            var number = this.packages.vueAnimate.downloads + this.packages.vueSeo.downloads + this.packages.vueOnline.downloads + this.packages.vueToastr.downloads + this.packages.vueErrorTracker.downloads + this.packages.vueTinymce.downloads + this.packages.distributedGenerators.downloads + this.packages.core.downloads + this.packages.laravelApiAuth.downloads + this.packages.laravelCoreTimeTracker.downloads;
            return number;
        }
    },
    components: {
        proPoint: __WEBPACK_IMPORTED_MODULE_0__components_pro_point___default.a,
        otherTech: __WEBPACK_IMPORTED_MODULE_1__components_other_tech___default.a,
        techBubble: __WEBPACK_IMPORTED_MODULE_2__components_tech_bubble___default.a,
        techTerminal: __WEBPACK_IMPORTED_MODULE_3__components_terminal___default.a,
        techPackage: __WEBPACK_IMPORTED_MODULE_4__components_package___default.a
    },
    created: function created() {
        this.getDownloads();
    },

    methods: {
        getDownloads: function getDownloads() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["a" /* getDownloads */]('vue-animate', {}, function (response) {
                _this.packages.vueAnimate.downloads = response.data.downloads;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["b" /* getStars */]('vue-animate', {}, function (response) {
                _this.packages.vueAnimate.stars = response.data.stargazers_count;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["a" /* getDownloads */]('vue-seo', {}, function (response) {
                _this.packages.vueSeo.downloads = response.data.downloads;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["b" /* getStars */]('vue-seo', {}, function (response) {
                _this.packages.vueSeo.stars = response.data.stargazers_count;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["a" /* getDownloads */]('vue-online', {}, function (response) {
                _this.packages.vueOnline.downloads = response.data.downloads;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["b" /* getStars */]('vue-online', {}, function (response) {
                _this.packages.vueOnline.stars = response.data.stargazers_count;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["a" /* getDownloads */]('vue-toastr', {}, function (response) {
                _this.packages.vueToastr.downloads = response.data.downloads;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["b" /* getStars */]('vue-toastr', {}, function (response) {
                _this.packages.vueToastr.stars = response.data.stargazers_count;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["a" /* getDownloads */]('vue-error-tracker', {}, function (response) {
                _this.packages.vueErrorTracker.downloads = response.data.downloads;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["b" /* getStars */]('vue-error-tracker', {}, function (response) {
                _this.packages.vueErrorTracker.stars = response.data.stargazers_count;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["a" /* getDownloads */]('vue-tinymce', {}, function (response) {
                _this.packages.vueTinymce.downloads = response.data.downloads;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["b" /* getStars */]('vue-tinymce', {}, function (response) {
                _this.packages.vueTinymce.stars = response.data.stargazers_count;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["c" /* getPackagistDownloads */]('distributed-generators', {}, function (response) {
                _this.packages.distributedGenerators.downloads = response.data.package.downloads.total;
                _this.packages.distributedGenerators.stars = response.data.package.github_stars;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["c" /* getPackagistDownloads */]('core', {}, function (response) {
                _this.packages.core.downloads = response.data.package.downloads.total;
                _this.packages.core.stars = response.data.package.github_stars;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["c" /* getPackagistDownloads */]('laravel-api-authenticator', {}, function (response) {
                _this.packages.laravelApiAuth.downloads = response.data.package.downloads.total;
                _this.packages.laravelApiAuth.stars = response.data.package.github_stars;
            }, function () {});
            __WEBPACK_IMPORTED_MODULE_5__infrastructure_services_packages_packageService__["c" /* getPackagistDownloads */]('laravel-core-time-tracker', {}, function (response) {
                _this.packages.laravelCoreTimeTracker.downloads = response.data.package.downloads.total;
                _this.packages.laravelCoreTimeTracker.stars = response.data.package.github_stars;
            }, function () {});
        }
    }
});

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */,
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 24,
	"./af.js": 24,
	"./ar": 31,
	"./ar-dz": 25,
	"./ar-dz.js": 25,
	"./ar-kw": 26,
	"./ar-kw.js": 26,
	"./ar-ly": 27,
	"./ar-ly.js": 27,
	"./ar-ma": 28,
	"./ar-ma.js": 28,
	"./ar-sa": 29,
	"./ar-sa.js": 29,
	"./ar-tn": 30,
	"./ar-tn.js": 30,
	"./ar.js": 31,
	"./az": 32,
	"./az.js": 32,
	"./be": 33,
	"./be.js": 33,
	"./bg": 34,
	"./bg.js": 34,
	"./bm": 35,
	"./bm.js": 35,
	"./bn": 36,
	"./bn.js": 36,
	"./bo": 37,
	"./bo.js": 37,
	"./br": 38,
	"./br.js": 38,
	"./bs": 39,
	"./bs.js": 39,
	"./ca": 40,
	"./ca.js": 40,
	"./cs": 41,
	"./cs.js": 41,
	"./cv": 42,
	"./cv.js": 42,
	"./cy": 43,
	"./cy.js": 43,
	"./da": 44,
	"./da.js": 44,
	"./de": 47,
	"./de-at": 45,
	"./de-at.js": 45,
	"./de-ch": 46,
	"./de-ch.js": 46,
	"./de.js": 47,
	"./dv": 48,
	"./dv.js": 48,
	"./el": 49,
	"./el.js": 49,
	"./en-au": 50,
	"./en-au.js": 50,
	"./en-ca": 51,
	"./en-ca.js": 51,
	"./en-gb": 52,
	"./en-gb.js": 52,
	"./en-ie": 53,
	"./en-ie.js": 53,
	"./en-nz": 54,
	"./en-nz.js": 54,
	"./eo": 55,
	"./eo.js": 55,
	"./es": 58,
	"./es-do": 56,
	"./es-do.js": 56,
	"./es-us": 57,
	"./es-us.js": 57,
	"./es.js": 58,
	"./et": 59,
	"./et.js": 59,
	"./eu": 60,
	"./eu.js": 60,
	"./fa": 61,
	"./fa.js": 61,
	"./fi": 62,
	"./fi.js": 62,
	"./fo": 63,
	"./fo.js": 63,
	"./fr": 66,
	"./fr-ca": 64,
	"./fr-ca.js": 64,
	"./fr-ch": 65,
	"./fr-ch.js": 65,
	"./fr.js": 66,
	"./fy": 67,
	"./fy.js": 67,
	"./gd": 68,
	"./gd.js": 68,
	"./gl": 69,
	"./gl.js": 69,
	"./gom-latn": 70,
	"./gom-latn.js": 70,
	"./gu": 71,
	"./gu.js": 71,
	"./he": 72,
	"./he.js": 72,
	"./hi": 73,
	"./hi.js": 73,
	"./hr": 74,
	"./hr.js": 74,
	"./hu": 75,
	"./hu.js": 75,
	"./hy-am": 76,
	"./hy-am.js": 76,
	"./id": 77,
	"./id.js": 77,
	"./is": 78,
	"./is.js": 78,
	"./it": 79,
	"./it.js": 79,
	"./ja": 80,
	"./ja.js": 80,
	"./jv": 81,
	"./jv.js": 81,
	"./ka": 82,
	"./ka.js": 82,
	"./kk": 83,
	"./kk.js": 83,
	"./km": 84,
	"./km.js": 84,
	"./kn": 85,
	"./kn.js": 85,
	"./ko": 86,
	"./ko.js": 86,
	"./ky": 87,
	"./ky.js": 87,
	"./lb": 88,
	"./lb.js": 88,
	"./lo": 89,
	"./lo.js": 89,
	"./lt": 90,
	"./lt.js": 90,
	"./lv": 91,
	"./lv.js": 91,
	"./me": 92,
	"./me.js": 92,
	"./mi": 93,
	"./mi.js": 93,
	"./mk": 94,
	"./mk.js": 94,
	"./ml": 95,
	"./ml.js": 95,
	"./mr": 96,
	"./mr.js": 96,
	"./ms": 98,
	"./ms-my": 97,
	"./ms-my.js": 97,
	"./ms.js": 98,
	"./mt": 99,
	"./mt.js": 99,
	"./my": 100,
	"./my.js": 100,
	"./nb": 101,
	"./nb.js": 101,
	"./ne": 102,
	"./ne.js": 102,
	"./nl": 104,
	"./nl-be": 103,
	"./nl-be.js": 103,
	"./nl.js": 104,
	"./nn": 105,
	"./nn.js": 105,
	"./pa-in": 106,
	"./pa-in.js": 106,
	"./pl": 107,
	"./pl.js": 107,
	"./pt": 109,
	"./pt-br": 108,
	"./pt-br.js": 108,
	"./pt.js": 109,
	"./ro": 110,
	"./ro.js": 110,
	"./ru": 111,
	"./ru.js": 111,
	"./sd": 112,
	"./sd.js": 112,
	"./se": 113,
	"./se.js": 113,
	"./si": 114,
	"./si.js": 114,
	"./sk": 115,
	"./sk.js": 115,
	"./sl": 116,
	"./sl.js": 116,
	"./sq": 117,
	"./sq.js": 117,
	"./sr": 119,
	"./sr-cyrl": 118,
	"./sr-cyrl.js": 118,
	"./sr.js": 119,
	"./ss": 120,
	"./ss.js": 120,
	"./sv": 121,
	"./sv.js": 121,
	"./sw": 122,
	"./sw.js": 122,
	"./ta": 123,
	"./ta.js": 123,
	"./te": 124,
	"./te.js": 124,
	"./tet": 125,
	"./tet.js": 125,
	"./th": 126,
	"./th.js": 126,
	"./tl-ph": 127,
	"./tl-ph.js": 127,
	"./tlh": 128,
	"./tlh.js": 128,
	"./tr": 129,
	"./tr.js": 129,
	"./tzl": 130,
	"./tzl.js": 130,
	"./tzm": 132,
	"./tzm-latn": 131,
	"./tzm-latn.js": 131,
	"./tzm.js": 132,
	"./uk": 133,
	"./uk.js": 133,
	"./ur": 134,
	"./ur.js": 134,
	"./uz": 136,
	"./uz-latn": 135,
	"./uz-latn.js": 135,
	"./uz.js": 136,
	"./vi": 137,
	"./vi.js": 137,
	"./x-pseudo": 138,
	"./x-pseudo.js": 138,
	"./yo": 139,
	"./yo.js": 139,
	"./zh-cn": 140,
	"./zh-cn.js": 140,
	"./zh-hk": 141,
	"./zh-hk.js": 141,
	"./zh-tw": 142,
	"./zh-tw.js": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(310),
  /* scopeId */
  "data-v-486a0984",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  "data-v-3230207e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  "data-v-7fc2f8ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  "data-v-e6633602",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)
__webpack_require__(250)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  "data-v-14c3fcde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(245)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  "data-v-078ddb6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)
__webpack_require__(254)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  "data-v-3f5fd683",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  "data-v-7b412553",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  "data-v-4b083719",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(317),
  /* scopeId */
  "data-v-bd1ee1cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(306),
  /* scopeId */
  "data-v-30694ff4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  "data-v-0c84da26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  "data-v-626b0d29",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(321),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)
__webpack_require__(246)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  "data-v-0c7608ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "casebg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                Quooker Skandinavien A/S\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Webshop - iOS applikation\n            ")])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light skew-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h3', [_vm._v("Udfordringen")]), _vm._v(" "), _c('p', [_vm._v("Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "infocard"
  }, [_c('h3', [_vm._v("Teknologier:")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Frontend")]), _vm._v(" "), _c('p', [_vm._v("JavaScript - Vue.js")]), _vm._v(" "), _c('h5', [_vm._v("Backend")]), _vm._v(" "), _c('p', [_vm._v("PHP - Laravel")]), _vm._v(" "), _c('h5', [_vm._v("Server")]), _vm._v(" "), _c('p', [_vm._v("Microsoft Azure VPS")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "solution"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 image"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 body-wrapper"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h3', [_vm._v("Løsningen")]), _vm._v(" "), _c('p', [_vm._v("Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. ")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "result"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 body-wrapper light"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h3', [_vm._v("Resultatet")]), _vm._v(" "), _c('p', [_vm._v("Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. Her skal der være en lang og spændende tekst. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 image"
  })])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Udtalelse her\n        ")])])])
}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "top-panel bg-deveo-gradient"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                CORE\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "300px"
    }
  })])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "102%",
      "height": "60px",
      "margin-top": "-86px",
      "z-index": "99"
    },
    attrs: {
      "src": "http://iqonicthemes.com/themes/sofbox/v1/images/banner/02.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "min-height": "400px",
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "hello",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": "/static/images/core.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "50%",
      "position": "absolute",
      "right": "0",
      "top": "-400px"
    },
    attrs: {
      "src": "http://iqonicthemes.com/themes/sofbox/v1/images/banner/01.png"
    }
  })])])])
}]}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'outer-' + _vm.$route.name,
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "deveo-wrapper",
    class: _vm.$route.name
  }, [_c('top-menu'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('main-footer', {
    attrs: {
      "skew": _vm.skewFooter
    }
  }), _vm._v(" "), _c('mobile-footer'), _vm._v(" "), (_vm.$store.state.mobileMenu) ? _c('mobile-menu') : _vm._e(), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), _c('cookie-notice')], 1)
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('seo-title', {
    attrs: {
      "content": _vm.$t('technology.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('technology.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('technology.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('technology.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-grey-gradient no-p-b",
    staticStyle: {
      "overflow": "hidden",
      "padding-top": "15vh",
      "margin-top": "-105px"
    }
  }, [_c('div', {
    staticClass: "tech-container"
  }, [_c('tech-bubble', {
    attrs: {
      "icon": "amazons3",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "babel",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "bootstrap",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "css3",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "docker",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "git",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "github",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "html5",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "javascript",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "jquery",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "laravel",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "less",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "mysql",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "nginx",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "nodejs",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "phpstorm",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "redis",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "sass",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "react",
      "size": "small"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "ssh",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "vue",
      "size": "large"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "webpack",
      "size": "medium"
    }
  }), _vm._v(" "), _c('tech-bubble', {
    attrs: {
      "icon": "wordpress",
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "arch",
    attrs: {
      "src": "/static/images/layout/arch.svg",
      "alt": "Arch"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white tech-intro"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('h2', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('technology.mainHeader')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('technology.mainText')) + "\n            ")])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 terminal-col align-self-center"
  }, [_c('tech-terminal')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5"
  }, [_c('h4', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('technology.coreFirst')) + " "), _c('span', {
    staticClass: "main-color"
  }, [_vm._v("Core")]), _c('sup', {
    staticClass: "sup-small"
  }, [_vm._v(" by Deveo")]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('technology.coreSecond')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "row small-icons-row",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-ios-bolt"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointOne')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointOneText')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-ios-pulse"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointTwo')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointTwoText')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-ios-locked"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointThree')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointThreeText')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i', {
    staticClass: "ion-arrow-graph-up-right main-color"
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('technology.corePointFour')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('technology.corePointFourText')))])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "align": "center"
    }
  }, [_c('h2', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('technology.opensourceHeader')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('technology.opensourceTextFirst'))), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('technology.opensourceTextSecond')) + " "), _c('b', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.totalDownloads))]), _vm._v(" " + _vm._s(_vm.$t('technology.opensourceTextThird')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  })]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "core",
      "downloads": _vm.packages.core.downloads,
      "stars": _vm.packages.core.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Artistic API framework based on laravel and larapi.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "distributed-generators",
      "downloads": _vm.packages.distributedGenerators.downloads,
      "stars": _vm.packages.distributedGenerators.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Smart generators for distributed laravel. Spin up new bundles in the matter of seconds.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "laravel-api-authenticator",
      "downloads": _vm.packages.laravelApiAuth.downloads,
      "stars": _vm.packages.laravelApiAuth.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        API authentication made simple.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "laravel",
      "header": "laravel-core-time-tracker",
      "downloads": _vm.packages.laravelCoreTimeTracker.downloads,
      "stars": _vm.packages.laravelCoreTimeTracker.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Advanced and highly precise time tracking of core users.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-animate",
      "downloads": _vm.packages.vueAnimate.downloads,
      "stars": _vm.packages.vueAnimate.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        An easy way to use beautiful animations on your site. Ideal for hero style landing pages.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-error-tracker",
      "downloads": _vm.packages.vueErrorTracker.downloads,
      "stars": _vm.packages.vueErrorTracker.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Vue error tracker keeps track of vue-resource http related errors, and provides an easy solution for tracking errors.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-online",
      "downloads": _vm.packages.vueOnline.downloads,
      "stars": _vm.packages.vueOnline.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        An easy way to show if a users browser is online with support for custom notification drivers.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-seo",
      "downloads": _vm.packages.vueSeo.downloads,
      "stars": _vm.packages.vueSeo.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        Easy way to add SEO to any vue based site. Works without jQuery.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-toastr",
      "downloads": _vm.packages.vueToastr.downloads,
      "stars": _vm.packages.vueToastr.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        A easy-to-use toastr notification plugin developed without jQuery.\n                    ")])]), _vm._v(" "), _c('tech-package', {
    attrs: {
      "type": "vue",
      "header": "vue-tinymce",
      "downloads": _vm.packages.vueTinymce.downloads,
      "stars": _vm.packages.vueTinymce.stars
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                        TinyMCE wrapper for vue.js without jQuery. Plug and play style with translation support.\n                    ")])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-bg-gradient skew top-panel services-top"
  }, [_c('div', {
    staticClass: "inside-skew"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    attrs: {
      "id": "service-window"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowBox === 1),
      expression: "windowBox === 1"
    }],
    attrs: {
      "src": "/static/images/services/window1.svg"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowBox === 2),
      expression: "windowBox === 2"
    }],
    attrs: {
      "src": "/static/images/services/window2.svg"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowBox === 3),
      expression: "windowBox === 3"
    }],
    attrs: {
      "src": "/static/images/services/window3.svg"
    }
  })])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "skew"
  }, [_c('div', {
    staticClass: "inside-skew"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row window-boxes animated fadeIn"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "window-box",
    class: {
      'active': _vm.windowBox === 1
    },
    on: {
      "click": function($event) {
        _vm.windowBox = 1
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('service.mainbox1Header')))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('service.mainbox1Text')) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "window-box",
    class: {
      'active': _vm.windowBox === 2
    },
    on: {
      "click": function($event) {
        _vm.windowBox = 2
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('service.mainbox2Header')))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('service.mainbox2Text')) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "window-box",
    class: {
      'active': _vm.windowBox === 3
    },
    on: {
      "click": function($event) {
        _vm.windowBox = 3
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('service.mainbox3Header')))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('service.mainbox3Text')) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', [_vm._v("\n                            " + _vm._s(_vm.$t('service.firstServiceHeader')) + "\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('service.firstServiceText')) + "\n                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-rounded btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('service.readmore')) + "\n                        ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light skew bottom-panel"
  }, [_c('div', {
    staticClass: "inside-skew"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', [_vm._v("\n                            " + _vm._s(_vm.$t('service.secondServiceHeader')) + "\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('service.secondServiceText')) + "\n                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-rounded btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('service.readmore')) + "\n                        ")])])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.railsware.com/images/services/web-services-5a281186.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.railsware.com/images/services/web-services-5a281186.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("\n                        ???\n                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "200px"
    }
  })])])])])
}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp"
  }, [_c('div', {
    staticClass: "pp-icon"
  }, [_c('i', {
    class: 'fa fa-' + _vm.icon
  })]), _vm._v(" "), _c('strong', [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._t("description")], 2)
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('seo-title', {
    attrs: {
      "content": _vm.$t('contact.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('contact.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('contact.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('contact.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "cph-bg top-panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "test"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contact.pageHeader')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contact.pageSubheader')) + "\n            ")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [(!_vm.submitted) ? _c('div', {
    staticClass: "contactform"
  }, [_c('h3', {
    staticClass: "contact-header"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('contact.contactformHeader')) + "\n                        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "netlify": "",
      "netlify-honeypot": "bot-field",
      "name": "contact"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contact.contactformName'),
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contact.contactformEmail'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contact.contactformPhone'),
      "name": "phone"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.message),
      expression: "form.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "type": "text",
      "placeholder": _vm.$t('contact.contactformMessage'),
      "name": "message"
    },
    domProps: {
      "value": (_vm.form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isValidated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [(_vm.isValidated) ? _c('span', [_vm._v("Send")]) : _c('span', [_vm._v(_vm._s(_vm.$t('contact.fillToSend')))])])])])])]) : _c('div', {
    staticClass: "contactform"
  }, [(_vm.submitSuccess) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('contact.formSuccessHeader')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('contact.formSuccessText')) + "\n                            ")])]) : _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('contact.formErrorHeader')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('contact.formErrorText')) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "cta-wrapper"
  }, [_c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tiny"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('contact.phoneHours')) + "\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('h3', [_c('a', {
    staticClass: "emaillink",
    attrs: {
      "href": "mailto:kontakt@deveo.dk"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('contact.emailText')) + "\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tiny"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('contact.emailHours')) + "\n                                ")])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "ion-android-phone-portrait"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('a', {
    staticClass: "emaillink",
    attrs: {
      "href": "tel:+4571992895"
    }
  }, [_vm._v("\n                                        +45 71 99 28 95\n                                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "ion-paper-airplane"
  })])])])])
}]}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'tech-bubble-wrapper ' + _vm.size + ' ' + _vm.icon
  }, [_c('img', {
    attrs: {
      "src": '/static/images/techicons/' + _vm.icon + '.svg'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-bg-gradient top-panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "test"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('press.pageHeader')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('press.pageSubheader')) + "\n            ")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('press.mediaTitle')))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('press.mediaTextFirst')) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('press.mediaTextSecond')) + " "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('press.mediaTextLink')))]), _vm._v(" " + _vm._s(_vm.$t('press.mediaTextThird')) + "\n                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('press.pressResponsibleTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "press-responsible"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/people/nicolai.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside-box"
  }, [_c('h6', [_vm._v("Nicolai Ramsby")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone fa-fw"
  }), _vm._v(" 31 45 88 37"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-envelope fa-fw"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:nr@deveo.dk"
    }
  }, [_vm._v(_vm._s(_vm.$t('press.pressResponsibleLink')))])])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Logo")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/logo/grey_right.svg"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "/static/images/logo/Deveo_logo.png",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw"
  }), _vm._v(" PNG\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "/static/images/logo/Deveo_logo.ai",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw"
  }), _vm._v(" AI\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "/static/images/logo/Deveo_logo.svg",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw"
  }), _vm._v(" SVG\n                    ")])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'Index'
      },
      "tag": "a"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": "/static/images/logo/white_right.svg"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ml-auto"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Technology'
      },
      "tag": "a"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('layout.menuTech')) + "\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Contact'
      },
      "tag": "a"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('layout.menuContact')) + "\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "to": {
        name: 'Login'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('layout.menuLogin')) + "\n                    ")])], 1)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 case-box",
    class: _vm.shortname
  }, [_c('div', {
    staticClass: "headline",
    class: _vm.position
  }, [_c('b', [_vm._v(_vm._s(_vm.name))]), _c('br'), _vm._v("\n        " + _vm._s(_vm.type) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "inside-overlay"
  }, [_vm._v("\n            Læs mere om vores løsning til "), _c('b', [_vm._v(_vm._s(_vm.name))])])])])
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('seo-title', {
    attrs: {
      "content": _vm.$t('index.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('index.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "webplatform, software, softwareudvikling, deveo, deveodk, deveo aps, vue, javascript, laravel, php, packages, open source"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('index.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('index.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-gradient top-panel skew"
  }, [_c('div', {
    staticClass: "container inside-skew"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-xs-12"
  }, [_c('h3', {
    staticClass: "header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.mainHeader'))), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "index-typer"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('index.firstService')) + "\n                        ")])]), _vm._v(" "), _c('p', {
    staticClass: "breadtext"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.mainText')) + "\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Contact'
      },
      "href": "#"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.mainContactButton')) + "\n                    ")])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white",
    staticStyle: {
      "margin-top": "-200px",
      "padding-top": "260px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 header-box",
    attrs: {
      "align": "right"
    }
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.$t('index.subHeaderFirst'))), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('index.subHeaderSecond')) + "\n                    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.subText')) + "\n                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "simple-link",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Technology'
      },
      "href": "#"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.subButton')) + " "), _c('i', {
    staticClass: "ion-arrow-right-c"
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light index-cases",
    staticStyle: {
      "margin-bottom": "60px",
      "position": "relative"
    }
  }, [_c('img', {
    staticClass: "bow",
    attrs: {
      "src": "/static/images/layout/bow.png",
      "alt": "bow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container outer-cases-small"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.$t('index.casesHeader')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fix-width"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('index.casesText')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "customer-wrapper row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "case quooker"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/quooker.svg",
      "alt": "Quooker"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "casetext"
  }, [_c('b', [_vm._v("\"")]), _vm._v("\n                            " + _vm._s(_vm.$t('index.quookerStatement')) + "\n                            "), _c('b', [_vm._v("\"")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('section', {
    staticClass: "index-iceberg"
  }, [_c('img', {
    staticClass: "arch",
    attrs: {
      "src": "/static/images/layout/arch-bottom.svg",
      "alt": "Arch"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "icebergwater"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titanic-container",
    style: ({
      left: _vm.titanic.x + 'px'
    })
  }, [_c('img', {
    staticClass: "titanic",
    attrs: {
      "src": "/static/images/iceberg/titanic.svg",
      "alt": "Titanic"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('index.icebergHeader')))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('index.icebergText')) + "\n                    ")])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('section', {
    staticClass: "cta-section"
  }, [_c('div', {
    staticClass: "container cta-container"
  }, [_c('div', {
    staticClass: "row cta-background"
  }, [_c('div', {
    staticClass: "col-lg-6 index-contact-cta"
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.$t('index.ctaHeader')) + "\n                        "), _c('span', [_vm._v(_vm._s(_vm.$t('index.ctaSubheader')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "cta-buttons"
  }, [_c('router-link', {
    staticClass: "cta-button",
    attrs: {
      "tag": "button",
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('index.ctaFirstButton')) + "\n                        ")])], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-7 index-devices"
  }, [_c('div', {
    staticClass: "device",
    attrs: {
      "id": "vw-device"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing/vw_new.svg",
      "alt": "Volkswagen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "device",
    attrs: {
      "id": "quooker-device"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing/quooker-shop-vertical-landing.svg",
      "alt": "Quooker"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "device",
    attrs: {
      "id": "atea-device"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing/mobilswap-horizontal-landing.svg",
      "alt": "Mobilswap"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "ion-ios-color-wand-outline"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Niclas Correll")]), _c('br'), _vm._v("\n                            Quooker Skandinavien A/S\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case half f2d"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/f2d.png",
      "alt": "FRESH2DEATH"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case half vw"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/volkswagen_large.svg",
      "alt": "Volkswagen"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "case large semler"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/semler.png",
      "alt": "Semler Retail A/S"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case large julehjaelpen"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/julehjaelpen.svg",
      "alt": "Julehjælpen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "case prominds"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/prominds.png",
      "alt": "Prominds"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case large fclarsen"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/fclarsen.png",
      "alt": "FC Larsen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case sepeeg"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/customers/sepeeg.png",
      "alt": "SEPEEG"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "cloud-container"
  }, [_c('div', {
    staticClass: "cloud"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud"
  }), _vm._v(" "), _c('div', {
    staticClass: "cloud"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('img', {
    staticClass: "iceberg-main",
    attrs: {
      "src": "/static/images/iceberg/main.svg",
      "alt": "Iceberg"
    }
  })])])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "top-panel skew main-bg-gradient"
  }, [_c('div', {
    staticClass: "container inside-skew"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.$t('about.pageHeader')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                xxx\n            ")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            XXX\n        ")])])
}]}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-footer"
  }, [(_vm.skew) ? _c('div', {
    staticClass: "skew-footer-top"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Index'
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": "/static/images/logo/white_right.svg",
      "alt": "Deveo logo"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t('layout.footerAbout')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "locale-wrapper"
  }, _vm._l((_vm.locales), function(locale, index) {
    return _c('div', {
      key: index,
      staticClass: "locale",
      class: {
        'active': _vm.$i18n.locale === index
      },
      on: {
        "click": function($event) {
          _vm.$i18n.locale = index
        }
      }
    }, [(index === 'da') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/dk.png",
        "alt": "Danish"
      }
    }) : _vm._e(), _vm._v(" "), (index === 'en') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/gb.png",
        "alt": "English"
      }
    }) : _vm._e()])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('layout.footerMenuHeader')))]), _vm._v(" "), _vm._l((_vm.sortedSocials), function(social) {
    return _c('a', {
      key: social.name,
      attrs: {
        "href": social.link
      }
    }, [_vm._v("\n                    " + _vm._s(social.name) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 contact"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('layout.footerContactHeader')))]), _vm._v(" "), _vm._l((_vm.contacts), function(contact) {
    return _c('a', {
      key: contact.icon,
      attrs: {
        "href": contact.link
      }
    }, [(contact.icon) ? _c('i', {
      class: 'fa fa-fw fa-' + contact.icon
    }) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(contact.title)
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 copyright"
  }, [_vm._v("\n                2014 - " + _vm._s(_vm.currentYear) + " © Deveo ApS    |    CVR: 38994778\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12 col-xs-12 package-wrapper"
  }, [_c('div', {
    staticClass: "card-shadow bg-deveo-light",
    class: 'card-' + _vm.type
  }, [(_vm.header === 'vue-toastr') ? _c('div', {
    staticClass: "most-popular"
  }, [_c('i', {
    staticClass: "fa fa-star fa-fw"
  }), _vm._v(" Most popular\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-logo"
  }, [(_vm.type === 'vue') ? _c('img', {
    staticClass: "grey",
    attrs: {
      "src": "/static/images/techicons/vue_grey.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'vue') ? _c('img', {
    staticClass: "white",
    attrs: {
      "src": "/static/images/techicons/vue_white.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'laravel') ? _c('img', {
    staticClass: "grey",
    attrs: {
      "src": "/static/images/techicons/laravel_grey.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'laravel') ? _c('img', {
    staticClass: "white",
    attrs: {
      "src": "/static/images/techicons/laravel_white.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _vm._t("description"), _vm._v(" "), _c('div', {
    staticClass: "card-downloads"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.downloads !== '' && _vm.downloads !== 0) ? _c('div', {
    staticClass: "col-lg-6 col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-download"
  }), _vm._v(" " + _vm._s(_vm.downloads) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.stars !== '' && _vm.stars !== 0) ? _c('div', {
    staticClass: "col-lg-6 col-xs-6"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-star"
  }), _vm._v(" " + _vm._s(_vm.stars) + "\n                ")]) : _vm._e()])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 other-techs",
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ('<strong>' + _vm.footer + '</strong><br>' + _vm.header),
      expression: "'<strong>' + footer + '</strong><br>' + header",
      modifiers: {
        "top-center": true
      }
    }]
  }, [_vm._t("svg")], 2)])
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "id": "cookienotice"
    }
  }, [_c('div', {
    attrs: {
      "id": "cookietopbar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "insidecookie"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.cookie.message')) + "\n        "), _c('div', {
    staticClass: "accept",
    on: {
      "click": _vm.acceptCookie
    }
  }, [_c('span', [_vm._v("\n                > " + _vm._s(_vm.$t('layout.cookie.yes')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "decline",
    on: {
      "click": _vm.goAway
    }
  }, [_c('span', [_vm._v("\n                > " + _vm._s(_vm.$t('layout.cookie.no')) + "\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-wrapper",
    class: _vm.shortname + ' ' + _vm.position + ' ' + _vm.loadedState
  }, [(_vm.loadedState === 'not-loaded') ? _c('div', {
    staticClass: "case-loader"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.position === 'right') ? _c('div', {
    staticClass: "col-lg-7"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 align-self-center"
  }, [_c('div', {
    staticClass: "case-inner"
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.name) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.type) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._t("description")], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot2"
  })])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-footer"
  }, [_c('a', {
    attrs: {
      "href": "tel:+4571992895"
    }
  }, [_c('div', {
    staticClass: "menuitem"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("\n            " + _vm._s(_vm.$t('layout.mobileFooter.phone')) + "\n        ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:hello@deveo.dk"
    }
  }, [_c('div', {
    staticClass: "menuitem"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v("\n            " + _vm._s(_vm.$t('layout.mobileFooter.email')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "menuitem",
    on: {
      "click": function($event) {
        _vm.$store.state.mobileMenu = !_vm.$store.state.mobileMenu
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("\n        " + _vm._s(_vm.$t('layout.mobileFooter.menu')) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temp-login-wrapper"
    }
  }, [_c('seo-title', {
    attrs: {
      "content": _vm.$t('login.meta.title')
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": _vm.$t('login.meta.description')
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": _vm.$t('login.meta.title')
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": _vm.$t('login.meta.description')
    }
  }), _vm._v(" "), _c('seo-og-image', {
    attrs: {
      "content": "/static/images/opengraph/fb_og.png"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-cont"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('login.header')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('login.text')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "to": {
        name: 'Index'
      },
      "tag": "a"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('login.button')) + "\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mobile-menu"
    }
  }, [_c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Index')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.menuIndex')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Technology')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.menuTech')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Contact')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.menuContact')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Login')
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('layout.menuLogin')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "escape-mobilemenu",
    on: {
      "click": function($event) {
        _vm.$store.state.mobileMenu = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "locale-wrapper"
  }, _vm._l((_vm.locales), function(locale, index) {
    return _c('div', {
      key: locale,
      staticClass: "locale",
      class: {
        'active': _vm.$i18n.locale === index
      },
      on: {
        "click": function($event) {
          _vm.$i18n.locale = index
        }
      }
    }, [(index === 'da') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/dk.png"
      }
    }) : _vm._e(), _vm._v(" "), (index === 'en') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/gb.png"
      }
    }) : _vm._e()])
  }))])
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-bg-gradient top-panel skew"
  }, [_c('div', {
    staticClass: "container inside-skew"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.$t('case.header')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('case.subheader')) + "\n                "), _c('br'), _c('br')])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container other-cases",
    attrs: {
      "align": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.$t('case.otherTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('case.otherText')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "cafelabonta"
  }, [_vm._v("Café Labonta")]), _vm._v(" "), _c('li', {
    staticClass: "f2d"
  }, [_vm._v("Fresh2Death")]), _vm._v(" "), _c('li', {
    staticClass: "farmsupportuganda"
  }, [_vm._v("Farm Support Uganda ")]), _vm._v(" "), _c('li', {
    staticClass: "fclarsen"
  }, [_vm._v("FC Larsen A/S")]), _vm._v(" "), _c('li', {
    staticClass: "firmagavexperten"
  }, [_vm._v("Firmagave"), _c('span', [_vm._v("X")]), _vm._v("perten")]), _vm._v(" "), _c('li', {
    staticClass: "firmajulegaver"
  }, [_vm._v("Firma"), _c('span', [_vm._v("jule")]), _vm._v("gaver")]), _vm._v(" "), _c('li', {
    staticClass: "jyderupsandblaeseri"
  }, [_vm._v("Jyderup Sandblæseri")]), _vm._v(" "), _c('li', {
    staticClass: "kunstnervaerkstedetroskilde"
  }, [_vm._v("Kunstnerværkstedet Roskilde")]), _vm._v(" "), _c('li', {
    staticClass: "learninginclusive"
  }, [_vm._v("Learning Inclusive")]), _vm._v(" "), _c('li', {
    staticClass: "ledberegner"
  }, [_vm._v("LEDberegner.dk")]), _vm._v(" "), _c('li', {
    staticClass: "macramecopenhagen"
  }, [_vm._v("Macrame Copenhagen")]), _vm._v(" "), _c('li', {
    staticClass: "oelstykkeerhvervsudlejning"
  }, [_vm._v("Ølstykke Erhvervsudlejning")]), _vm._v(" "), _c('li', {
    staticClass: "peaksport"
  }, [_vm._v("Peak Sport")]), _vm._v(" "), _c('li', {
    staticClass: "projectpoint"
  }, [_vm._v("ProjectPoint")]), _vm._v(" "), _c('li', {
    staticClass: "sepeeg"
  }, [_vm._v("SEPEEG")]), _vm._v(" "), _c('li', {
    staticClass: "solarvarme"
  }, [_vm._v("Solarvarme")]), _vm._v(" "), _c('li', {
    staticClass: "styleguy"
  }, [_vm._v("StyleGuy")]), _vm._v(" "), _c('li', {
    staticClass: "taastrupdyreklinik"
  }, [_vm._v("Taastrup Dyreklinik")]), _vm._v(" "), _c('li', {
    staticClass: "tieman"
  }, [_vm._v("TieMan")]), _vm._v(" "), _c('li', {
    staticClass: "toppaint"
  }, [_vm._v("To"), _c('span', [_vm._v("p")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("p")]), _vm._v("a"), _c('span', [_vm._v("i")]), _vm._v("nt")]), _vm._v(" "), _c('li', {
    staticClass: "touchrepair"
  }, [_vm._v("TouchRep"), _c('span', [_vm._v("a")]), _vm._v("ir")]), _vm._v(" "), _c('li', {
    staticClass: "vistasrevisor"
  }, [_vm._v("Vistas Revisor")])])
}]}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terminal-wrapper"
  }, [_c('div', {
    staticClass: "terminal-topbar"
  }, [_c('svg', {
    attrs: {
      "width": "500px",
      "height": "100px",
      "viewBox": "0 0 500 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#F62834",
      "cx": "50",
      "cy": "50",
      "r": "50"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#8BAF1B",
      "cx": "250",
      "cy": "50",
      "r": "50"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#FBAC3E",
      "cx": "450",
      "cy": "50",
      "r": "50"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "terminal-inner bg-deveo-light"
  }, [(_vm.showTerminal) ? _c('pre', [_c('vue-typer', {
    attrs: {
      "text": ["$ vue init deveodk/vue-core"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 0,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n\n"), _c('vue-typer', {
    attrs: {
      "text": ["Project name: "],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 4000,
      "type-delay": 0,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _c('vue-typer', {
    attrs: {
      "text": ["awesome-project"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 4500,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n\n    "), _c('vue-typer', {
    attrs: {
      "text": ["Generated: awesome-project"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 7000,
      "type-delay": 0,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n\n"), _c('vue-typer', {
    attrs: {
      "text": ["$ cd awesome-project"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 8000,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n"), _c('vue-typer', {
    attrs: {
      "text": ["$ npm install"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 11500,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n"), _c('vue-typer', {
    attrs: {
      "text": ["$ npm run dev"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 13500,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n")], 1) : _c('pre', [_vm._v("\n\n\n\n\n\n\n\n\n")])])])
},staticRenderFns: []}

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/lang/da.lang.json": 331,
	"./about/lang/en.lang.json": 332,
	"./case/lang/da.lang.json": 333,
	"./case/lang/en.lang.json": 334,
	"./contact/lang/da.lang.json": 335,
	"./contact/lang/en.lang.json": 336,
	"./core/lang/da.lang.json": 337,
	"./core/lang/en.lang.json": 338,
	"./index/lang/da.lang.json": 339,
	"./index/lang/en.lang.json": 340,
	"./layout/lang/da.lang.json": 341,
	"./layout/lang/en.lang.json": 342,
	"./login/lang/da.lang.json": 343,
	"./login/lang/en.lang.json": 344,
	"./press/lang/da.lang.json": 345,
	"./press/lang/en.lang.json": 346,
	"./service/lang/da.lang.json": 347,
	"./service/lang/en.lang.json": 348,
	"./technology/lang/da.lang.json": 349,
	"./technology/lang/en.lang.json": 350
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 329;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/routes.js": 171,
	"./case/routes.js": 172,
	"./contact/routes.js": 173,
	"./core/routes.js": 174,
	"./index/routes.js": 175,
	"./login/routes.js": 176,
	"./press/routes.js": 177,
	"./service/routes.js": 178,
	"./technology/routes.js": 179
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 330;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = {"pageHeader":"Om Deveo"}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = {"pageHeader":"About Deveo"}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = {"header":"Kundecases","subheader":"Et udsnit af de løsninger, som vi har leveret.","vwType":"Landingside","vwText":"Beskrivelse","qType":"Reservedelsplatform - Webshop","qText":"Beskrivelse","jhType":"Donationsplatform - Hjemmeside","jhText":"Beskrivelse","apmpType":"Landingside","apmpText":"Beskrivelse","gwType":"Hjemmeside","gwText":"Beskrivelse","otherTitle":"Andre referencer","otherText":"Vi har også hjulpet disse virksomheder med diverse web-opgaver"}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = {"header":"xxx","subheader":"xxx","vwType":"xxx","vwText":"xxx","qType":"xxx","qText":"xxx","jhType":"xxx","jhText":"xxx","apmpType":"xxx","apmpText":"xxx","gwType":"xxx","gwText":"xxx","otherTitle":"Other references","otherText":"We've also helped these companies with miscellaneous web projects"}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = {"pageHeader":"I hjertet af København ...","pageSubheader":"... sidder et team af udviklere (og vi vil meget gerne snakke med dig!)","contactformHeader":"Send os en besked","contactformName":"Navn","contactformPhone":"Telefon","contactformEmail":"E-mail","contactformMessage":"Din besked","phoneHours":"Hverdage: 10.00 - 18.00","emailText":"Send os en mail","emailHours":"Hverdage: 10.00 - 18.00","fillToSend":"Udfyld for at sende","formSuccessHeader":"Tak for din besked","formSuccessText":"Vi kontakter dig snarest","formErrorHeader":"Hov! Noget gik galt","formErrorText":"Vi beklager, men der skete en fejl. Kontakt os venligst på telefon +45 71 99 28 95 eller kontakt@deveo.dk","meta":{"title":"Deveo | Kontakt os","description":"I hjertet af København sidder et team af udviklere (og vi vil meget gerne snakke med dig!)"}}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = {"pageHeader":"In the heart of Copenhagen ...","pageSubheader":"... is a team of developers (and we'd love to talk to you!)","contactformHeader":"Send us a message","contactformName":"Name","contactformPhone":"Phone","contactformEmail":"Email","contactformMessage":"Your message","phoneHours":"Weekdays: 10.00 - 18.00","emailText":"Send us an email","emailHours":"Weekdays: 10:00 - 18:00","fillToSend":"Fill to send","formSuccessHeader":"Thank you for your message","formSuccessText":"We will contact you soon","formErrorHeader":"Whoops! Something went wrong","formErrorText":"We're sorry, but there was an error. Please contact us at +45 71 99 28 95 or kontakt@deveo.dk","meta":{"title":"Deveo | Contact us","description":"In the heart of Copenhagen is a team of developers (and we'd love to talk to you!)"}}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = {"introText":"xxx","firstBoxHeader":"Moderne","firstBoxText":"xxx","secondBoxHeader":"Sikkert","secondBoxText":"xxx","thirdBoxHeader":"Skalerbart","thirdBoxText":"xxx","localizationHeader":"Lokalisering","localizationFirst":"xxx","localizationSecond":"xxx","errorhandlingHeader":"Fejlhåndtering","errorhandlingFirst":"xxx","compatibilityHeader":"Kompatibilitet","compatibilityFirst":"xxx"}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = {"introText":"xxx","firstBoxHeader":"Modern","firstBoxText":"xxx","secondBoxHeader":"Secure","secondBoxText":"xxx","thirdBoxHeader":"Scalable","thirdBoxText":"xxx","localizationHeader":"Localization","localizationFirst":"xxx","localizationSecond":"xxx","errorhandlingHeader":"Error handling","errorhandlingFirst":"xxx","compatibilityHeader":"Compatibility","compatibilityFirst":"xxx"}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = {"chooseLang":"Vælg sprog","mainHeader":"Vi udvikler og designer","firstService":"webplatforme","secondService":"systemer","thirdService":"hjemmesider","fourthService":"webshops","fifthService":"applikationer","mainText":"Software skal være simpelt, intuitivt og godt udviklet. Vi specialiserer os i moderne løsninger og sætter fokus på brugervenlighed og stabilitet.","mainCasesButton":"Kundecases","mainContactButton":"Kontakt os","subHeaderFirst":"Stærk software skaber","subHeaderSecond":"stærke brands","subText":"Software er det bedste vi ved! Vi har en bred viden inden for mange forskellige typer kodesprog og vi følger hele tiden med i de nyeste udviklinger og teknologier. Vi bygger stabile softwareløsninger, som fx intranet, portaler, systemer - ja, faktisk alt hvad der har med datahåndtering at gøre.","subButton":"Tag et kig under motorhjelmen","opensourceHeader":"Open source pakker","opensourceText":"Vi elsker at dele vores kode og gøre internettet til et bedre sted. Vi har allerede bidraget med mere end 30 komponenter til open-source og det stiger løbende.","opensourceButton":"Se vores open-source pakker","coreHeader":"Introducerer Core","coreText":"Core er vores Mona Lisa. Core kombinerer det bedste inden for teknologi og brugervenlighed og giver dig som kunde en skalerbar base for din forretning.","coreButton":"Læs mere om Core","casesHeader":"Du er i godt selskab.","casesText":"Vi udvikler alt fra komplekse webplatforme til simple hjemmesider og webshops.","icebergHeader":"Simpelt på overfladen, men avanceret under.","icebergText":"Vi skaber avancerede platforme, som er simple og brugervenlige på overfladen.","ctaHeader":"Klar til at komme igang?","ctaSubheader":"Tag en uforpligtende snak om din nye løsning","ctaFirstButton":"Jeg er klar!","quookerStatement":"Resultatet har været mere end tilfredsstillende. Platformen lever op til forventningerne og sparer os for unødvendigt meget manuelt arbejde på daglig basis.","meta":{"title":"Deveo | Vi udvikler og designer webplatforme","description":"Software er det bedste vi ved! Vi har en bred viden inden for mange forskellige typer kodesprog og vi følger hele tiden med i de nyeste udviklinger og teknologier. Vi bygger stabile softwareløsninger, som fx intranet, portaler, systemer - ja, faktisk alt hvad der har med datahåndtering at gøre."}}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = {"chooseLang":"Choose language","mainHeader":"We develop and design","firstService":"web platforms","secondService":"systems","thirdService":"websites","fourthService":"webshops","fifthService":"applications","mainText":"Software must be simple, intuitive and well-developed. We specialize in modern solutions and focus on user-friendliness and stability.","mainCasesButton":"Customer Cases","mainContactButton":"Contact us","subHeaderFirst":"Strong software creates","subHeaderSecond":"strong brands","subText":"Software is the best we know! We have broad knowledge in many different types of code languages, and we constantly follow the latest developments and technologies. We build stable software solutions such as intranets, portals, systems - yes , in fact, all that has to do with data management.","subButton":"Take a look under the bonnet","opensourceHeader":"Open source packages","opensourceText":"We love sharing our code and making the internet a better place. We've already contributed more than 30 components for open source and it's constantly rising.","opensourceButton":"See our open-source packages","coreHeader":"Introducing Core","coreText":"Core is our Mona Lisa. Core combines the best in technology and user-friendliness and provides you with a scalable base for your business.","coreButton":"Read more about Core","casesHeader":"You are in good company.","casesText":"We develop everything from complex web platforms to simple websites and webshops.","icebergHeader":"Simple on the surface, but advanced below.","icebergText":"We create advanced platforms that are simple and user-friendly on the surface.","ctaHeader":"Ready to get started?","ctaSubheader":"Let's have a talk about your new solution","ctaFirstButton":"I'm ready!","quookerStatement":"The final result has been more than satisfactory. The platform meets the expectations and saves us unnecessary manual work on a daily basis.","meta":{"title":"Deveo | We develop and design web platforms","description":"Software is the best we know! We have broad knowledge in many different types of code languages, and we constantly follow the latest developments and technologies. We build stable software solutions such as intranets, portals, systems - yes , in fact, all that has to do with data management."}}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = {"menuIndex":"Forside","menuOffers":"Vi tilbyder","menuTech":"Hvad vi kan","menuCases":"Kundecases","menuAbout":"Om Deveo","menuContact":"Kontakt","menuLogin":"Log ind","footerPress":"Presseside","footerJob":"Forespørg på opgave","footerContactHeader":"Kontakt os","footerMenuHeader":"Følg vores arbejde","footerAbout":"Vi specialiserer os i at levere skræddersyede softwareløsninger til såvel store virksomheder som små. Vi har især fokus på procesoptimering og kan i de fleste tilfælde hjælpe virksomheden med at spare penge.","mobileFooter":{"phone":"Ring os op","email":"Skriv til os","menu":"Menu"},"cookie":{"message":"Vi elsker at analysere og optimere. Vi håber derfor, at vi gerne må bruge nogle af dine cookies til dette. Vi lover at de smager godt.","yes":"Ja, det er helt i orden!","no":"Nej, tag mig væk!"}}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = {"menuIndex":"Home","menuOffers":"We offer","menuTech":"What we do","menuCases":"Cases","menuOm":"About Deveo","menuContact":"Contact us","menuLogin":"Login","footerPress":"Press","footerJob":"Project inquiry","footerContactHeader":"Contact Us","footerMenuHeader":"Follow our work","footerAbout":"We specialize in providing tailor-made software solutions for both small and large businesses. We focus especially on process optimization and can, in most cases, help the company save money.","mobileFooter":{"phone":"Call us","email":"Text us","menu":"Menu"},"cookie":{"message":"We love to analyze and optimize. We do this on this site too by using cookies. We hope it's okay that we use some of yours too. We promise they'll be tasty.","yes":"Sure, no problem!","no":"No, make me leave!"}}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = {"header":"Som kunde hos Deveo vil det snart være muligt at logge ind og administrere din løsning.","text":"Vi er dog ikke helt klar endnu, men hold dig opdateret på vores Facebookside.","button":"Gå tilbage til hovedsiden","meta":{"title":"Deveo | Log ind","description":"Som kunde hos Deveo vil det snart være muligt at logge ind og administrere din løsning."}}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = {"header":"As a customer at Deveo, it will soon be possible to log in and manage your solution.","text":"However, we are not yet ready yet, but stay updated on our Facebook page.","button":"Return to main page","meta":{"title":"Deveo | Login","description":"As a customer at Deveo, it will soon be possible to log in and manage your solution."}}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = {"pageHeader":"Presse","pageSubheader":"Har kan du læse omkring artikler samt indlæg, som er skrevet af eller om Deveo. Denne side indeholder ligeledes informationer af særlig relevans for journalister og medier.","mediaTitle":"Deveo i medierne","mediaTextFirst":"Vi har endnu ikke lavet en optræden i de danske medier foruden Facebook og LinkedIn. Er du som journalist interesseret i at lave et interview med os, stiller vi os gerne til rådighed.","mediaTextSecond":"På siden","mediaTextLink":"Om Deveo","mediaTextThird":"vil du kunne læse mere om hvem os bag virksomheden er.","pressResponsibleTitle":"Presseansvarlig","pressResponsibleLink":"Send en mail"}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = {"pageHeader":"Press","pageSubheader":"Here you can read more about the articles and posts written by or about Deveo. This page also contains relevant information for journalists and the media.","mediaTitle":"Deveo in the media","mediaTextFirst":"We have yet to be featured in the media. If you are a journalist and are interested in doing an interview with us, we would love to participate. Feel free to contact us.","mediaTextSecond":"On the page","mediaTextLink":"About Deveo","mediaTextThird":"you will be able to read more about the people running the company.","pressResponsibleTitle":"Press responsible","pressResponsibleLink":"Send a mail"}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = {"mainbox1Header":"Hjemmesider","mainbox1Text":"Brødtekst","mainbox2Header":"Web platforme","mainbox2Text":"Brødtekst","mainbox3Header":"Mac, Windows & Linux applikationer","mainbox3Text":"Brødtekst","firstServiceHeader":"Service","firstServiceText":"Brødtekst","secondServiceHeader":"Service","secondServiceText":"Brødtekst","readmore":"Læs mere"}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = {"mainbox1Header":"Title","mainbox1Text":"Text here","mainbox2Header":"Title","mainbox2Text":"Text here","mainbox3Header":"Title","mainbox3Text":"Text here","firstServiceHeader":"Service","firstServiceText":"Text here","secondServiceHeader":"Service","secondServiceText":"Text here","readmore":"Read more"}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = {"mainHeader":"En stærk platform skabes med stærke teknologier.","mainText":"For at skabe den perfekte løsning, kombinerer vi nogle af de bedste teknologier der sammen med smart design bliver til en elegant løsning.","coreFirst":"Lad os præsentere","coreSecond":"- Vores svar på en solid start","corePointOne":"Hastighed","corePointOneText":"Avanceret arkitektur, der er bygget til at undgå n+1 problematikker.","corePointTwo":"Stabilitet","corePointTwoText":"Bygget til at fange og håndtere fejl - såvel i backend som frontend.","corePointThree":"Sikkerhed","corePointThreeText":"Med standarder som OAuth2 og JWT i ryggen bliver det ikke meget sikrere.","corePointFour":"Skalerbarhed","corePointFourText":"Bygget specifikt med horisontal skalering i mente - uanset IaaS udbyder.","opensourceHeader":"Open-source pakker","opensourceTextFirst":"Et udsnit af vores populære selvudviklede open-source pakker.","opensourceTextSecond":"Gør som","opensourceTextThird":"andre og forkæl din platform.","meta":{"title":"Deveo | Det kan vi","description":"For at skabe den perfekte løsning, kombinerer vi nogle af de bedste teknologier der sammen med smart design bliver til en elegant løsning."}}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = {"mainHeader":"A strong platform created with powerful technologies.","mainText":"To create the perfect solution, we combine some of the best technologies that, together with smart design, become an elegant solution.","coreFirst":"Let's introduce","coreSecond":"- Our answer to a solid start","corePointOne":"Speed","corePointOneText":"Advanced architecture built to avoid n + 1 issues.","corePointTwo":"Stability","corePointTwoText":"Built to capture and handle errors - both in backend and frontend.","corePointThree":"Security","corePointThreeText":"With standards like OAuth2 and JWT in the back, it does not come much safer.","corePointFour":"Scalability","corePointFourText":"Built specifically with horizontal scaling in mind - regardless of IaaS provider.","opensourceHeader":"Open-source packages","opensourceTextFirst":"A sample of our popular self-developed open-source packages.","opensourceTextSecond":"Do like","opensourceTextThird":"others and treat your platform like it deserves.","meta":{"title":"Deveo | What we do","description":"To create the perfect solution, we combine some of the best technologies that together with smart design will be an elegant solution."}}

/***/ })
]),[182]);


// WEBPACK FOOTER //
// static/js/app.f1cf0116be91b1fd271b.js